import React, { useState, FormEvent, useEffect } from 'react'
import { Eye, EyeOff, Check, X, User, Lock, Mail } from 'lucide-react'
import { PasswordService } from '../services/password.service'

interface LoginProps {
  onLogin: (username: string, password: string) => void
}

export const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [loginForm, setLoginForm] = useState({ username: '', password: '' })
  const [showPassword, setShowPassword] = useState(false)
  const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false)
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('')
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState('')
  const [forgotPasswordError, setForgotPasswordError] = useState('')
  
  // Logo para el panel derecho (fondo claro/oscuro) — texto adapta con CSS
  const AxiumLogoAdaptive = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2153 730" style={{ width: '100%', height: 'auto', display: 'block' }}>
      <path className="axium-text" fillRule="nonzero" d="M 575.11 530.84 A 0.31 0.3 -16.15 0 1 574.85 531.3 Q 557.83 531.48, 517.43 531.39 Q 512.61 531.37, 509.87 526.74 Q 499.82 509.74, 444.61 419.62 Q 388.87 328.65, 369.22 297.22 C 367.68 294.76, 364.53 294.91, 363.17 297.23 Q 346.69 325.4, 326.31 358.26 C 295.59 407.81, 262.52 461.94, 236.89 502.74 Q 225.5 520.86, 222.14 526.63 C 219.84 530.57, 217.59 531.42, 213.02 531.41 Q 185.54 531.36, 156.75 531.34 A 0.53 0.53 -68.24 0 1 156.37 530.45 Q 157.03 529.75, 157.69 528.71 Q 173.33 503.91, 217.39 433.39 C 238.02 400.37, 261.36 361.17, 282.96 325.94 Q 311.46 279.47, 334.69 241.22 Q 337.92 235.91, 345.37 232.55 Q 349.54 230.68, 357.84 230.95 Q 362.23 231.09, 374.1 230.9 Q 385.21 230.71, 388.72 232.23 C 395.77 235.28, 398.54 238.4, 402.82 245.68 Q 424.16 282, 452.47 328.57 Q 550.12 489.24, 558.4 503.06 Q 570.23 522.81, 575.11 530.84 Z M 1140.84 530.86 A 0.53 0.53 0 0 1 1140.31 531.39 L 1095.91 531.39 A 0.53 0.53 0 0 1 1095.38 530.86 L 1095.38 298.22 A 0.53 0.53 0 0 1 1095.91 297.69 L 1140.31 297.69 A 0.53 0.53 0 0 1 1140.84 298.22 L 1140.84 530.86 Z M 1520.06 297.64 L 1563.85 297.64 A 0.52 0.52 45 0 1 1564.37 298.16 Q 1564.45 399.84, 1564.24 423.97 Q 1564.09 440.82, 1558.1 460.39 Q 1550.68 484.59, 1532.26 501.35 C 1515.32 516.75, 1492.41 525.55, 1470.17 530.12 Q 1455.44 533.14, 1440.48 533.75 C 1407.95 535.08, 1375.71 532.68, 1345.51 519.22 Q 1303.95 500.72, 1291.71 457 Q 1286.34 437.82, 1286.33 417.74 Q 1286.3 356.41, 1286.31 297.98 A 0.34 0.33 0 0 1 1286.65 297.65 L 1332.2 297.65 A 0.54 0.54 45 0 1 1332.74 298.19 Q 1332.75 395.37, 1332.8 422.24 Q 1332.82 429.18, 1335.05 439.52 Q 1340.89 466.58, 1365.09 478.41 Q 1377.99 484.71, 1393.27 487.15 Q 1424.61 492.15, 1458 487.47 C 1482.61 484.02, 1507.84 470.33, 1515.58 445.08 Q 1517.74 438.05, 1518.79 429.46 Q 1519.33 425.02, 1519.32 413.52 Q 1519.27 343.23, 1519.32 298.37 A 0.74 0.73 0 0 1 1520.06 297.64 Z M 966.73 298.4 Q 966.73 298.49, 966.7 298.64 A 0.21 0.2 74.63 0 1 966.63 298.77 L 838.33 414.79 A 0.6 0.6 44.39 0 0 838.34 415.68 Q 896.94 467.19, 966.52 531.23 Q 966.76 531.45, 966.7 531.7 Q 966.61 532.05, 966.26 532.05 Q 919.4 532.12, 906.01 532.13 Q 903.39 532.13, 902.08 530.95 Q 850.15 484.22, 805.12 444.45 A 0.74 0.73 -45.29 0 0 804.14 444.46 L 706.21 531.5 A 1.94 1.91 -65.56 0 1 704.93 531.99 Q 649.51 532.05, 642.77 532.19 Q 641.91 532.21, 641.54 531.87 A 0.4 0.39 45.43 0 1 641.54 531.28 L 771.53 417.14 A 0.64 0.63 -44.43 0 0 771.54 416.19 L 641.14 298.99 A 0.53 0.53 -23.91 0 1 641.5 298.06 L 703.85 298.06 A 1.94 1.91 65.56 0 1 705.13 298.55 L 803.89 387.32 A 0.55 0.54 44.57 0 0 804.62 387.32 L 902.52 298.79 A 2.98 2.97 23.83 0 1 904.52 298.02 L 966.29 297.99 A 0.44 0.44 87.9 0 1 966.73 298.4 Z M 1951.81 366.97 Q 1904.68 420.48, 1856.55 478.29 C 1854.01 481.34, 1842.79 480.62, 1839.01 480.42 Q 1835.86 480.25, 1833.28 478.91 A 3.09 3.09 -55.02 0 1 1832.33 478.16 C 1807.28 448.71, 1769.25 403.68, 1736.62 366.95 Q 1736.21 366.48, 1735.85 366.65 A 0.21 0.2 -14.98 0 0 1735.74 366.83 L 1735.74 530.79 A 0.62 0.62 32.83 0 1 1735.12 531.41 L 1690.66 531.41 A 0.45 0.45 -51.82 0 1 1690.21 530.96 L 1690.21 298.56 A 0.52 0.51 0 0 1 1690.73 298.05 Q 1717.55 297.83, 1730.34 298.12 Q 1733.11 298.18, 1736.49 300.44 A 3.82 3.55 -2.1 0 1 1737.22 301.07 L 1844.45 425.08 A 0.34 0.33 44.52 0 0 1844.96 425.08 Q 1870.96 394.3, 1894.16 367.66 Q 1922.96 334.6, 1951.56 301.32 Q 1954.25 298.19, 1959.3 298.14 Q 1982.04 297.89, 1997.48 298.1 A 0.51 0.5 0.58 0 1 1997.98 298.6 L 1997.98 530.92 A 0.48 0.48 -45 0 1 1997.5 531.4 L 1952.96 531.4 A 0.49 0.49 33.75 0 1 1952.47 530.91 L 1952.47 367.22 A 0.38 0.38 65.7 0 0 1951.81 366.97 Z"/>
      <path className="axium-logo-triangle" fillRule="nonzero" d="M 377.95 519.73 A 11.65 11.65 0 0 1 366.3 531.38 L 365.68 531.38 A 11.65 11.65 0 0 1 354.03 519.73 L 354.03 376.53 A 11.65 11.65 0 0 1 365.68 364.88 L 366.3 364.88 A 11.65 11.65 0 0 1 377.95 376.53 L 377.95 519.73 Z"/>
      <path className="axium-bar-blue" fillRule="nonzero" d="M 334.68 519.6 A 11.74 11.74 0 0 1 322.94 531.34 L 322.3 531.34 A 11.74 11.74 0 0 1 310.56 519.6 L 310.56 441.14 A 11.74 11.74 0 0 1 322.3 429.4 L 322.94 429.4 A 11.74 11.74 0 0 1 334.68 441.14 L 334.68 519.6 Z"/>
      <path className="axium-bar-green" fillRule="nonzero" d="M 420.96 519.73 A 11.63 11.63 0 0 1 409.33 531.36 L 408.75 531.36 A 11.63 11.63 0 0 1 397.12 519.73 L 397.12 440.99 A 11.63 11.63 0 0 1 408.75 429.36 L 409.33 429.36 A 11.63 11.63 0 0 1 420.96 440.99 L 420.96 519.73 Z M 464.38 519.98 A 11.36 11.36 0 0 1 453 531.32 L 451.72 531.32 A 11.36 11.36 0 0 1 440.38 519.94 L 440.42 498.98 A 11.36 11.36 0 0 1 451.8 487.64 L 453.08 487.64 A 11.36 11.36 0 0 1 464.42 499.02 L 464.38 519.98 Z"/>
      <path className="axium-bar-blue" fillRule="nonzero" d="M 291.8 519.9 A 11.33 11.33 0 0 1 280.49 531.25 L 279.23 531.25 A 11.33 11.33 0 0 1 267.88 519.94 L 267.84 499.06 A 11.33 11.33 0 0 1 279.15 487.71 L 280.41 487.71 A 11.33 11.33 0 0 1 291.76 499.02 L 291.8 519.9 Z"/>
    </svg>
  )

  // Logo inline SVG — blanco para panel oscuro, adaptable para header claro/oscuro
  const AxiumLogoWhite = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2153 730" style={{ width: '100%', height: 'auto', display: 'block', maxWidth: 280 }}>
      <path fill="white" fillRule="nonzero" d="M 575.11 530.84 A 0.31 0.3 -16.15 0 1 574.85 531.3 Q 557.83 531.48, 517.43 531.39 Q 512.61 531.37, 509.87 526.74 Q 499.82 509.74, 444.61 419.62 Q 388.87 328.65, 369.22 297.22 C 367.68 294.76, 364.53 294.91, 363.17 297.23 Q 346.69 325.4, 326.31 358.26 C 295.59 407.81, 262.52 461.94, 236.89 502.74 Q 225.5 520.86, 222.14 526.63 C 219.84 530.57, 217.59 531.42, 213.02 531.41 Q 185.54 531.36, 156.75 531.34 A 0.53 0.53 -68.24 0 1 156.37 530.45 Q 157.03 529.75, 157.69 528.71 Q 173.33 503.91, 217.39 433.39 C 238.02 400.37, 261.36 361.17, 282.96 325.94 Q 311.46 279.47, 334.69 241.22 Q 337.92 235.91, 345.37 232.55 Q 349.54 230.68, 357.84 230.95 Q 362.23 231.09, 374.1 230.9 Q 385.21 230.71, 388.72 232.23 C 395.77 235.28, 398.54 238.4, 402.82 245.68 Q 424.16 282, 452.47 328.57 Q 550.12 489.24, 558.4 503.06 Q 570.23 522.81, 575.11 530.84 Z M 1140.84 530.86 A 0.53 0.53 0 0 1 1140.31 531.39 L 1095.91 531.39 A 0.53 0.53 0 0 1 1095.38 530.86 L 1095.38 298.22 A 0.53 0.53 0 0 1 1095.91 297.69 L 1140.31 297.69 A 0.53 0.53 0 0 1 1140.84 298.22 L 1140.84 530.86 Z M 1520.06 297.64 L 1563.85 297.64 A 0.52 0.52 45 0 1 1564.37 298.16 Q 1564.45 399.84, 1564.24 423.97 Q 1564.09 440.82, 1558.1 460.39 Q 1550.68 484.59, 1532.26 501.35 C 1515.32 516.75, 1492.41 525.55, 1470.17 530.12 Q 1455.44 533.14, 1440.48 533.75 C 1407.95 535.08, 1375.71 532.68, 1345.51 519.22 Q 1303.95 500.72, 1291.71 457 Q 1286.34 437.82, 1286.33 417.74 Q 1286.3 356.41, 1286.31 297.98 A 0.34 0.33 0 0 1 1286.65 297.65 L 1332.2 297.65 A 0.54 0.54 45 0 1 1332.74 298.19 Q 1332.75 395.37, 1332.8 422.24 Q 1332.82 429.18, 1335.05 439.52 Q 1340.89 466.58, 1365.09 478.41 Q 1377.99 484.71, 1393.27 487.15 Q 1424.61 492.15, 1458 487.47 C 1482.61 484.02, 1507.84 470.33, 1515.58 445.08 Q 1517.74 438.05, 1518.79 429.46 Q 1519.33 425.02, 1519.32 413.52 Q 1519.27 343.23, 1519.32 298.37 A 0.74 0.73 0 0 1 1520.06 297.64 Z M 966.73 298.4 Q 966.73 298.49, 966.7 298.64 A 0.21 0.2 74.63 0 1 966.63 298.77 L 838.33 414.79 A 0.6 0.6 44.39 0 0 838.34 415.68 Q 896.94 467.19, 966.52 531.23 Q 966.76 531.45, 966.7 531.7 Q 966.61 532.05, 966.26 532.05 Q 919.4 532.12, 906.01 532.13 Q 903.39 532.13, 902.08 530.95 Q 850.15 484.22, 805.12 444.45 A 0.74 0.73 -45.29 0 0 804.14 444.46 L 706.21 531.5 A 1.94 1.91 -65.56 0 1 704.93 531.99 Q 649.51 532.05, 642.77 532.19 Q 641.91 532.21, 641.54 531.87 A 0.4 0.39 45.43 0 1 641.54 531.28 L 771.53 417.14 A 0.64 0.63 -44.43 0 0 771.54 416.19 L 641.14 298.99 A 0.53 0.53 -23.91 0 1 641.5 298.06 L 703.85 298.06 A 1.94 1.91 65.56 0 1 705.13 298.55 L 803.89 387.32 A 0.55 0.54 44.57 0 0 804.62 387.32 L 902.52 298.79 A 2.98 2.97 23.83 0 1 904.52 298.02 L 966.29 297.99 A 0.44 0.44 87.9 0 1 966.73 298.4 Z M 1951.81 366.97 Q 1904.68 420.48, 1856.55 478.29 C 1854.01 481.34, 1842.79 480.62, 1839.01 480.42 Q 1835.86 480.25, 1833.28 478.91 A 3.09 3.09 -55.02 0 1 1832.33 478.16 C 1807.28 448.71, 1769.25 403.68, 1736.62 366.95 Q 1736.21 366.48, 1735.85 366.65 A 0.21 0.2 -14.98 0 0 1735.74 366.83 L 1735.74 530.79 A 0.62 0.62 32.83 0 1 1735.12 531.41 L 1690.66 531.41 A 0.45 0.45 -51.82 0 1 1690.21 530.96 L 1690.21 298.56 A 0.52 0.51 0 0 1 1690.73 298.05 Q 1717.55 297.83, 1730.34 298.12 Q 1733.11 298.18, 1736.49 300.44 A 3.82 3.55 -2.1 0 1 1737.22 301.07 L 1844.45 425.08 A 0.34 0.33 44.52 0 0 1844.96 425.08 Q 1870.96 394.3, 1894.16 367.66 Q 1922.96 334.6, 1951.56 301.32 Q 1954.25 298.19, 1959.3 298.14 Q 1982.04 297.89, 1997.48 298.1 A 0.51 0.5 0.58 0 1 1997.98 298.6 L 1997.98 530.92 A 0.48 0.48 -45 0 1 1997.5 531.4 L 1952.96 531.4 A 0.49 0.49 33.75 0 1 1952.47 530.91 L 1952.47 367.22 A 0.38 0.38 65.7 0 0 1951.81 366.97 Z"/>
      <path className="axium-logo-triangle" fillRule="nonzero" d="M 377.95 519.73 A 11.65 11.65 0 0 1 366.3 531.38 L 365.68 531.38 A 11.65 11.65 0 0 1 354.03 519.73 L 354.03 376.53 A 11.65 11.65 0 0 1 365.68 364.88 L 366.3 364.88 A 11.65 11.65 0 0 1 377.95 376.53 L 377.95 519.73 Z"/>
      <path className="axium-bar-blue" fillRule="nonzero" d="M 334.68 519.6 A 11.74 11.74 0 0 1 322.94 531.34 L 322.3 531.34 A 11.74 11.74 0 0 1 310.56 519.6 L 310.56 441.14 A 11.74 11.74 0 0 1 322.3 429.4 L 322.94 429.4 A 11.74 11.74 0 0 1 334.68 441.14 L 334.68 519.6 Z"/>
      <path className="axium-bar-green" fillRule="nonzero" d="M 420.96 519.73 A 11.63 11.63 0 0 1 409.33 531.36 L 408.75 531.36 A 11.63 11.63 0 0 1 397.12 519.73 L 397.12 440.99 A 11.63 11.63 0 0 1 408.75 429.36 L 409.33 429.36 A 11.63 11.63 0 0 1 420.96 440.99 L 420.96 519.73 Z M 464.38 519.98 A 11.36 11.36 0 0 1 453 531.32 L 451.72 531.32 A 11.36 11.36 0 0 1 440.38 519.94 L 440.42 498.98 A 11.36 11.36 0 0 1 451.8 487.64 L 453.08 487.64 A 11.36 11.36 0 0 1 464.42 499.02 L 464.38 519.98 Z"/>
      <path className="axium-bar-blue" fillRule="nonzero" d="M 291.8 519.9 A 11.33 11.33 0 0 1 280.49 531.25 L 279.23 531.25 A 11.33 11.33 0 0 1 267.88 519.94 L 267.84 499.06 A 11.33 11.33 0 0 1 279.15 487.71 L 280.41 487.71 A 11.33 11.33 0 0 1 291.76 499.02 L 291.8 519.9 Z"/>
    </svg>
  )

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    onLogin(loginForm.username, loginForm.password)
  }

  const handleForgotPasswordSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setForgotPasswordMessage('')
    setForgotPasswordError('')
    try {
      const response = await PasswordService.forgotPassword(forgotPasswordEmail)
      setForgotPasswordMessage(response.message)
    } catch (error: any) {
      console.error('Error en la solicitud de recuperación de contraseña:', error)
      setForgotPasswordError(
        error.message || 'Ocurrió un error inesperado. Inténtelo de nuevo más tarde.'
      )
    }
  }

  const handleCloseModal = () => {
    setIsForgotPasswordModalOpen(false)
    setForgotPasswordEmail('')
    setForgotPasswordMessage('')
    setForgotPasswordError('')
  }

  return (
    <div className="login-page">
      {/* Panel izquierdo - Branding con animaciones */}
      <div className="login-branding">
        {/* Formas flotantes */}
        <div className="login-branding__shapes">
          <div className="login-branding__shape" />
          <div className="login-branding__shape" />
          <div className="login-branding__shape" />
          <div className="login-branding__shape" />
          <div className="login-branding__shape" />
        </div>

        {/* Líneas animadas */}
        <div className="login-branding__lines">
          <div className="login-branding__line" />
          <div className="login-branding__line" />
          <div className="login-branding__line" />
        </div>

        {/* Contenido */}
        <div className="login-branding__content">
          <div className="login-branding__logo">
            <AxiumLogoWhite />
          </div>
          <p className="login-branding__tagline">
            Soluciones inteligentes para tu negocio
          </p>

          <div className="login-branding__features">
            <div className="login-branding__feature">
              <span className="login-branding__feature-icon">
                <Check size={12} />
              </span>
              Envíos masivos de correos
            </div>
            <div className="login-branding__feature">
              <span className="login-branding__feature-icon">
                <Check size={12} />
              </span>
              Speech Analytics
            </div>
            <div className="login-branding__feature">
              <span className="login-branding__feature-icon">
                <Check size={12} />
              </span>
              Chatbot con IA
            </div>
          </div>
        </div>
      </div>

      {/* Panel derecho - Formulario */}
      <div className="login-form-panel">
        <div className="login-form-container">
          {/* Header */}
          <div className="login-header">
            <div className="login-header__logo">
              <AxiumLogoAdaptive />
            </div>
            <h1 className="login-header__title">Bienvenido</h1>
            <p className="login-header__subtitle">Ingresa tus credenciales para continuar</p>
          </div>

          {/* Form */}
          <form onSubmit={onSubmit} className="login-form">
            {/* Campo Usuario */}
            <div className="login-form__group">
              <div className="login-form__input-wrapper">
                <input
                  id="login-identifier"
                  name="identifier"
                  type="text"
                  autoComplete="username"
                  value={loginForm.username}
                  onChange={(e) =>
                    setLoginForm({ ...loginForm, username: e.target.value })
                  }
                  className="login-form__input"
                  placeholder="email"
                  required
                />
                <User size={18} className="login-form__input-icon" />
                <label htmlFor="login-identifier" className="login-form__label">
                  Usuario o Email
                </label>
                <span className="login-form__input-line" />
              </div>
            </div>

            {/* Campo Contraseña */}
            <div className="login-form__group">
              <div className="login-form__input-wrapper">
                <input
                  id="login-password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  value={loginForm.password}
                  onChange={(e) =>
                    setLoginForm({ ...loginForm, password: e.target.value })
                  }
                  className="login-form__input"
                  placeholder="password"
                  required
                />
                <Lock size={18} className="login-form__input-icon" />
                <label htmlFor="login-password" className="login-form__label">
                  Contraseña
                </label>
                <span className="login-form__input-line" />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="login-form__toggle-password"
                  aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              <button
                type="button"
                onClick={() => setIsForgotPasswordModalOpen(true)}
                className="login-form__forgot-link"
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>

            <button type="submit" className="login-form__submit">
              Iniciar Sesión
            </button>
          </form>
        </div>
      </div>

      {/* Modal Recuperar Contraseña */}
      {isForgotPasswordModalOpen && (
        <div className="login-modal-overlay" onClick={handleCloseModal}>
          <div className="login-modal" onClick={(e) => e.stopPropagation()}>
            <div className="login-modal__header">
              <h2 className="login-modal__title">Recuperar Contraseña</h2>
              <button
                type="button"
                className="login-modal__close"
                onClick={handleCloseModal}
                aria-label="Cerrar"
              >
                <X size={20} />
              </button>
            </div>
            
            <form onSubmit={handleForgotPasswordSubmit} className="login-modal__form">
              <p className="login-modal__description">
                Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
              </p>
              
              <div className="login-form__group">
                <div className="login-form__input-wrapper">
                  <input
                    id="forgot-password-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={forgotPasswordEmail}
                    onChange={(e) => setForgotPasswordEmail(e.target.value)}
                    className="login-form__input"
                    placeholder="email"
                    required
                  />
                  <Mail size={18} className="login-form__input-icon" />
                  <label htmlFor="forgot-password-email" className="login-form__label">
                    Email
                  </label>
                  <span className="login-form__input-line" />
                </div>
              </div>

              {forgotPasswordMessage && (
                <p className="login-modal__message--success">{forgotPasswordMessage}</p>
              )}
              
              {forgotPasswordError && (
                <p className="login-modal__message--error">{forgotPasswordError}</p>
              )}

              <button type="submit" className="login-form__submit">
                Enviar enlace
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}